import React, { useMemo } from 'react';
import { Content, Progress } from '@backstage/core-components';
import { Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { getApiErrorMessage } from '../../../shared/api/getApiErrorMessage';
import { BackToTeams } from '../components/TeamDetails/BackToTeams';
import { TeamDetails } from '../components/TeamDetails/TeamDetails';
import { useTeam } from '../components/TeamDetails/useTeam';
import { useTeamApplicationContexts } from '../components/TeamDetails/useTeamApplicationContexts';
import { useTeamMembers } from '../components/TeamDetails/useTeamMembers';
import { mapApiTeam } from '../components/TeamsGrid/mapApiTeam';

export default function TeamDetailsPage() {
  const { teamId } = useParams();
  const teamQuery = useTeam(teamId);
  const applicationContextsQuery = useTeamApplicationContexts(teamId);
  const membersQuery = useTeamMembers(teamId);
  const team = useMemo(() => {
    if (!teamQuery.data) {
      return undefined;
    }

    return mapApiTeam(teamQuery.data, {
      applicationContexts: applicationContextsQuery.isSuccess
        ? applicationContextsQuery.data.elements
        : undefined,
      members: membersQuery.isSuccess ? membersQuery.data.elements : undefined,
    });
  }, [
    applicationContextsQuery.data,
    applicationContextsQuery.isSuccess,
    membersQuery.data,
    membersQuery.isSuccess,
    teamQuery.data,
  ]);

  if (teamQuery.isPending) {
    return (
      <Content>
        <BackToTeams />
        <Progress />
      </Content>
    );
  }

  if (teamQuery.isError || !team) {
    return (
      <Content>
        <BackToTeams />
        <Typography>
          {getApiErrorMessage(teamQuery.error, 'Team not found')}
        </Typography>
      </Content>
    );
  }

  return (
    <Content>
      <TeamDetails key={team.id} team={team} />
    </Content>
  );
}
